import { defineType } from 'sanity';

export const tabsSection = defineType({
    name: 'tabsSection',
    title: 'Tabs section',
    type: 'object',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'localizedString',
        },
        {
            name: 'description',
            title: 'Description',
            type: 'localizedText',
        },
        {
            name: 'tabs',
            title: 'Tabs',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        {
                            name: 'label',
                            title: 'Tab Label',
                            type: 'localizedString',
                        },
                        {
                            name: 'content',
                            title: 'Tab Content',
                            type: 'localizedString',
                        },
                    ],
                },
            ],
        },
        {
            name: 'variant',
            title: 'Variant',
            type: 'string',
            options: {
                list: [
                    { title: 'Variant A', value: 'A' },
                    { title: 'Variant B', value: 'B' },
                    { title: 'Variant C', value: 'C' },
                ],
            },
        },
    ],
    preview: {
        select: {
            title: 'title',
        },
        prepare({ title }) {
            return {
                title: `Tabs Section: ${title['en'] || title['sr']}`,
            };
        },
    },
});
